// extracted by mini-css-extract-plugin
export default {"base":"vp_fw4Gy","item":"vp_q9BMI","button":"vp_uKY5q","label":"vp_WOYbn","active":"vp_dSBlv","content":"vp_E4Ypw","arrow":"vp_U4711","visible":"vp_TvD7r"};